import { PaginationQuery } from "@/types";

export enum TMSPalletStatus {
  Upcoming = "Upcoming",
  OnStack = "OnStack",
  OffStack = "OffStack",
  OnStage = "OnStage",
  Shipping = "Shipping",
  Delivered = "Delivered",
  Deleted = "Deleted",
  Working = "Working",
}

export enum TMSPalletPriority {
  High = "High",
  Medium = "Medium",
  Normal = "Normal",
}

export interface TMSPalletVo {
  id: string;
  no: string;
  orderId: string;
  slotId?: string;
  groupName: string;
  status: TMSPalletStatus;
  priority: TMSPalletPriority;
  hold: boolean;
  quantity: number;
  addressId?: string;
  scanGroupId?: number;
  serialNo?: string;
  createdAt: string;
  updatedAt: string;
  //
  riiOrderNo?: string;
  //
  scannedCartonSkus?: string[];
  dimension?: TMSPalletDimension;
}

export interface TMSPalletSearchParams extends Partial<PaginationQuery> {
  orderIds?: string[];
  groupIds?: number[];
  statusList?: TMSPalletStatus[];
  excludeStatusList?: TMSPalletStatus[];
  includeScannedCartonSkus?: boolean;
}

export interface TMSScanPalletProductVo {
  id: number;
  palletId: string;
  productId: number;
  sscc: string;
  quantity: number;
  serialNo: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TMSPalletDimension {
  width: number;
  height: number;
  length: number;
  weight: number;
}

export interface TMSScanPalletCompleteDo {
  dimension?: TMSPalletDimension;
}

export interface TMSScanOrderLabelsUploadDo {
  type: "PDF",
  productPages: Record<number, string>;
}